import {remCalc} from '_themeUtils'

const sizeSelector = {
    SizeSelector: {
        baseStyle: () => ({
            sizesRowWrapper: {
                w: '100%',
                maxH: {base: remCalc(270), md: 'auto'},
                alignItems: 'flex-start',
                pt: 'spacing.4',
                pb: {base: 'spacing.none', md: 'spacing.8'},
                overflowY: {base: 'scroll', md: 'unset'},
            },
            sizesRow: {
                w: '100%',
                flexDirection: {base: 'column', md: 'row'},
                alignItems: 'flex-start',
                flexWrap: 'wrap',
                columnGap: {base: 'spacing.none', md: 'spacing.4'},
                rowGap: {base: 'spacing.none', md: 'spacing.1'},
            },
            sizeLabelWrapper: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: {base: 'space-between', md: 'center'},
                w: {base: '100%', md: 'auto'},
                minW: remCalc(30),
                minH: remCalc(30),
                textStyle: {base: 'paragraphMd', md: 'paragraphXs'},
                letterSpacing: remCalc(3),
                fontWeight: 400,
                p: 'spacing.1',
                cursor: 'pointer',
                border: '1px solid',
                borderColor: 'color.border.transparent',
                borderTopColor: {base: 'color.border.grey.300', md: 'color.border.transparent'},
                trasition: 'all 0.3s ease',
                _hover: {
                    borderColor: 'color.border.black',
                },
            },
            sizeLabelOutOfStockWrapper: {
                _hover: {
                    borderColor: 'color.border.transparent',
                },
            },
            selectedSizeLabelWrapper: {
                borderColor: 'color.border.black',
                borderTopColor: 'color.border.black',
            },
            sizeLabel: {
                my: {base: 'spacing.3', md: 'spacing.none'},
                pl: {base: 'spacing.1', md: 'spacing.none'},
            },
            sizeLabelOutOfStock: {
                color: 'color.text.grey.600',
                textDecoration: 'line-through',
                cursor: 'not-allowed',
            },
            labelStockInfo: {
                textStyle: 'paragraphSm',
                letterSpacing: remCalc(1),
                color: 'color.text.black',
                textDecoration: 'none',
            },
            labelOnlyOneInfo: {
                textStyle: 'paragraphSm',
                letterSpacing: remCalc(1),
                color: 'color.text.grey.600',
                textDecoration: 'none',
            },
            selectionTitle: {
                textStyle: 'paragraphMd',
                fontWeight: 400,
                letterSpacing: remCalc(0.6),
                mb: 'spacing.5',
            },
            selectionTitleError: {
                color: 'color.text.error',
            },
        }),
        variants: {
            wishlist: {
                sizesRowWrapper: {
                    maxH: 'unset',
                    overflowY: 'hidden',
                    pt: {base: 0, xl: 'spacing.4'},
                    pb: 'spacing.8',
                },
                sizesRow: {
                    flexDir: 'row',
                    rowGap: 'spacing.1',
                    columnGap: 'spacing.4',
                },
                sizeLabelWrapper: {
                    justifyContent: 'center',
                    w: 'auto',
                    textStyle: 'paragraphXs',
                    borderTopColor: 'color.border.transparent',
                },
                sizeLabel: {
                    my: 'spacing.none',
                    pl: 'spacing.none',
                },
            },
        },
    },
}

export default sizeSelector
